import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import * as firebase from 'firebase';

interface Template {
    UID: string;
    UID_RESTAURANT: string;
    public: boolean;
    type: string;
    url: string;
}




@Injectable()
export class TemplatesServices {
    public db: any;
    templatesCol: AngularFirestoreCollection<Template>;
    templates: Observable<Template[]>;
    templates_basic: Observable<Template[]>;
    templates_nadal: Observable<Template[]>;
    templateDoc: AngularFirestoreDocument<Template>;
    template: any;

    //TMP
    public menu_dish_array_tmp: any = Array();
    public menu_dish_array_complete_tmp: any;
    public template_tmp: Template = {
        UID: '',
        UID_RESTAURANT: '',
        public: false,
        type: '',
        url: '',
    };


    constructor(public afs: AngularFirestore) {
        this.db = firebase.firestore();
    }

    getList() {
        this.templatesCol = this.afs.collection('templates', ref => ref.where('public', '==', true));
        this.templates = this.templatesCol.snapshotChanges().map(actions => {
            return actions.map(a => {
                const data = a.payload.doc.data() as Template;
                data.UID = a.payload.doc.id;
                return data;
            });
        });
    }

    getListBasic() {
        this.templatesCol = this.afs.collection('templates', ref => ref.where('public', '==', true).where('type', '==', 'basic'));
        this.templates_basic = this.templatesCol.snapshotChanges().map(actions => {
            return actions.map(a => {
                const data = a.payload.doc.data() as Template;
                data.UID = a.payload.doc.id;
                return data;
            });
        });
    }

    getListNadal() {
        this.templatesCol = this.afs.collection('templates', ref => ref.where('public', '==', true).where('type', '==', 'nadal'));
        this.templates_nadal = this.templatesCol.snapshotChanges().map(actions => {
            return actions.map(a => {
                const data = a.payload.doc.data() as Template;
                data.UID = a.payload.doc.id;
                return data;
            });
        });
    }

}



// WEBPACK FOOTER //
// ./src/pages/services/templates.ts